import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sm-configure-online-payment',
  templateUrl: './configure-online-payment.component.html',
  styleUrls: ['./configure-online-payment.component.scss']
})
export class ConfigureOnlinePaymentComponent implements OnInit,OnDestroy {
  panelState: any = [true, false, false, false, false];
  private _apiSubscription: Subscription = new Subscription();
  onlinePaymentsObj: any = {
    hashId: '',
    email: null,
    bank_name: null,
    branch_name: null,
    account_number: null,
    account_holder_name: null,
    ifsc_code: null,
    pan_card_number: null,
    accountType: 0,
    refund_period: 5
    
  }
  businessType:any =  [
    "llp",
    "ngo",
    "other",
    "individual",
    "partnership",
    "proprietorship",
    "public_limited",
    "private_limited",
    "trust, society",
    "not_yet_registered",
    "educational_institutes"
  ]
  businessCategories = [
    { category: "financial_services", subcategories: [
      "mutual_fund",
      "lending",
      "cryptocurrency",
      "insurance",
      "nbfc",
      "cooperatives",
      "pension_fund",
      "forex",
      "securities",
      "commodities",
      "accounting",
      "financial_advisor",
      "crowdfunding",
      "trading",
      "betting",
      "get_rich_schemes",
      "moneysend_funding",
      "wire_transfers_and_money_orders",
      "tax_preparation_services",
      "tax_payments",
      "digital_goods",
      "atms"
    ] },
    { category: "education", subcategories: [
      "college",
      "schools",
      "university",
      "professional_courses",
      "distance_learning",
      "day_care",
      "coaching",
      "elearning",
      "vocational_and_trade_schools",
      "sporting_clubs",
      "dance_halls_studios_and_schools",
      "correspondence_schools"
    ] },
    { category: "healthcare", subcategories: [
      "pharmacy",
      "clinic",
      "hospital",
      "lab",
      "dietician",
      "fitness",
      "health_coaching",
      "health_products",
      "drug_stores",
      "healthcare_marketplace",
      "osteopaths",
      "medical_equipment_and_supply_stores",
      "podiatrists_and_chiropodists",
      "dentists_and_orthodontists",
      "hardware_stores",
      "ophthalmologists",
      "orthopedic_goods_stores",
      "testing_laboratories",
      "doctors",
      "health_practitioners_medical_services"
    ] },
    { category: "ecommerce", subcategories: [
      "ecommerce_marketplace",
      "agriculture",
      "books",
      "electronics_and_furniture",
      "coupons",
      "rental",
      "fashion_and_lifestyle",
      "gifting",
      "grocery",
      "baby_products",
      "office_supplies",
      "wholesale",
      "religious_products",
      "pet_products",
      "sports_products",
      "arts_and_collectibles",
      "sexual_wellness_products",
      "drop_shipping",
      "crypto_machinery",
      "tobacco",
      "weapons_and_ammunitions",
      "stamps_and_coins_stores",
      "office_equipment",
      "automobile_parts_and_equipements",
      "garden_supply_stores",
      "household_appliance_stores",
      "non_durable_goods",
      "pawn_shops",
      "electrical_parts_and_equipment",
      "wig_and_toupee_shops",
      "gift_novelty_and_souvenir_shops",
      "duty_free_stores",
      "office_and_commercial_furniture",
      "dry_goods",
      "books_and_publications",
      "camera_and_photographic_stores",
      "record_shops",
      "meat_supply_stores",
      "leather_goods_and_luggage",
      "snowmobile_dealers",
      "men_and_boys_clothing_stores",
      "paint_supply_stores",
      "automotive_parts",
      "jewellery_and_watch_stores",
      "auto_store_home_supply_stores",
      "tent_stores",
      "shoe_stores_retail",
      "petroleum_and_petroleum_products",
      "department_stores",
      "automotive_tire_stores",
      "sport_apparel_stores",
      "variety_stores",
      "chemicals_and_allied_products",
      "commercial_equipments",
      "fireplace_parts_and_accessories",
      "family_clothing_stores",
      "fabric_and_sewing_stores",
      "home_supply_warehouse",
      "art_supply_stores",
      "camper_recreational_and_utility_trailer_dealers",
      "clocks_and_silverware_stores",
      "discount_stores",
      "school_supplies_and_stationery",
      "second_hand_stores",
      "watch_and_jewellery_repair_stores",
      "liquor_stores",
      "boat_dealers",
      "opticians_optical_goods_and_eyeglasse_stores",
      "wholesale_footwear_stores",
      "cosmetic_stores",
      "home_furnishing_stores",
      "antique_stores",
      "plumbing_and_heating_equipment",
      "telecommunication_equipment_stores",
      "women_clothing",
      "florists",
      "computer_software_stores",
      "building_material_stores",
      "candy_nut_confectionery_shops",
      "glass_and_wallpaper_stores",
      "commercial_photography_and_graphic_design_services",
      "video_game_supply_stores",
      "fuel_dealers",
      "drapery_and_window_coverings_stores",
      "hearing_aids_stores",
      "automotive_paint_shops",
      "durable_goods_stores",
      "uniforms_and_commercial_clothing_stores",
      "fur_shops",
      "industrial_supplies",
      "bicycle_stores",
      "motorcycle_shops_and_dealers",
      "children_and_infants_wear_stores",
      "women_accessory_stores",
      "construction_materials",
      "books_periodicals_and_newspaper",
      "floor_covering_stores",
      "crystal_and_glassware_stores",
      "accessory_and_apparel_stores",
      "hardware_equipment_and_supply_stores",
      "computers_peripheral_equipment_software",
      "automobile_and_truck_dealers",
      "aircraft_and_farm_equipment_dealers",
      "antique_shops_sales_and_repairs",
      "music_stores",
      "furniture_and_home_furnishing_store"
    ] },
    { category: "services", subcategories: [
      "repair_and_cleaning",
      "interior_design_and_architect",
      "movers_and_packers",
      "legal",
      "event_planning",
      "service_centre",
      "consulting",
      "ad_and_marketing",
      "services_classifieds",
      "multi_level_marketing",
      "construction_services",
      "architectural_services",
      "car_washes",
      "motor_home_rentals",
      "stenographic_and_secretarial_support_services",
      "chiropractors",
      "automotive_service_shops",
      "shoe_repair_shops",
      "telecommunication_service",
      "fines",
      "security_agencies",
      "tailors",
      "type_setting_and_engraving_services",
      "small_appliance_repair_shops",
      "photography_labs",
      "dry_cleaners",
      "massage_parlors",
      "electronic_repair_shops",
      "cleaning_and_sanitation_services",
      "nursing_care_facilities",
      "direct_marketing",
      "lottery",
      "veterinary_services",
      "affiliated_auto_rental",
      "alimony_and_child_support",
      "airport_flying_fields",
      "golf_courses",
      "tire_retreading_and_repair_shops",
      "television_cable_services",
      "recreational_and_sporting_camps",
      "barber_and_beauty_shops",
      "agricultural_cooperatives",
      "carpentry_contractors",
      "wrecking_and_salvaging_services",
      "automobile_towing_services",
      "video_tape_rental_stores",
      "miscellaneous_repair_shops",
      "motor_homes_and_parts",
      "horse_or_dog_racing",
      "laundry_services",
      "electrical_contractors",
      "debt_marriage_personal_counseling_service",
      "air_conditioning_and_refrigeration_repair_shops",
      "credit_reporting_agencies",
      "heating_and_plumbing_contractors",
      "carpet_and_upholstery_cleaning_services",
      "swimming_pools",
      "roofing_and_metal_work_contractors",
      "internet_service_providers",
      "recreational_camps",
      "masonry_contractors",
      "exterminating_and_disinfecting_services",
      "ambulance_services",
      "funeral_services_and_crematories",
      "metal_service_centres",
      "copying_and_blueprinting_services",
      "fuel_dispensers",
      "welding_repair",
      "mobile_home_dealers",
      "concrete_work_contractors",
      "boat_rentals",
      "personal_shoppers_and_shopping_clubs",
      "door_to_door_sales",
      "travel_related_direct_marketing",
      "lottery_and_betting",
      "bands_orchestras_and_miscellaneous_entertainers",
      "furniture_repair_and_refinishing",
      "contractors",
      "direct_marketing_and_subscription_merchants",
      "typewriter_stores_sales_service_and_rentals",
      "recreation_services",
      "direct_marketing_insurance_services",
      "business_services",
      "inbound_telemarketing_merchants",
      "public_warehousing",
      "outbound_telemarketing_merchants",
      "clothing_rental_stores",
      "transportation_services",
      "electric_razor_stores",
      "service_stations",
      "photographic_studio",
      "professional_services"
    ] },
    { category: "housing", subcategories: [
      "developer",
      "facility_management",
      "rwa",
      "coworking",
      "realestate_classifieds",
      "space_rental"
    ] },
    { category: "not_for_profit", subcategories: [
      "charity",
      "educational",
      "religious",
      "personal"
    ] },
    { category: "social", subcategories: [
      "matchmaking",
      "social_network",
      "messaging",
      "professional_network",
      "neighbourhood_network",
      "political_organizations",
      "automobile_associations_and_clubs",
      "country_and_athletic_clubs",
      "associations_and_membership"
    ] },
    { category: "media_and_entertainment", subcategories: [
      "video_on_demand",
      "music_streaming",
      "multiplex",
      "content_and_publishing",
      "ticketing",
      "news",
      "video_game_arcades",
      "video_tape_production_and_distribution",
      "bowling_alleys",
      "billiard_and_pool_establishments",
      "amusement_parks_and_circuses",
      "ticket_agencies"
    ] },
    { category: "gaming", subcategories: [
      "game_developer",
      "esports",
      "online_casino",
      "fantasy_sports",
      "gaming_marketplace"
    ] },
    { category: "it_and_software", subcategories: [
      "saas",
      "paas",
      "iaas",
      "consulting_and_outsourcing",
      "web_development",
      "technical_support",
      "data_processing"
    ] },
    { category: "food", subcategories: [
      "online_food_ordering",
      "restaurant",
      "food_court",
      "catering",
      "alcohol",
      "restaurant_search_and_booking",
      "dairy_products",
      "bakeries"
    ] },
    { category: "utilities", subcategories: [
      "electricity",
      "gas",
      "telecom",
      "water",
      "cable",
      "broadband",
      "dth",
      "internet_provider",
      "bill_and_recharge_aggregators"
    ] },
    { category: "government", subcategories: [
      "central",
      "state",
      "intra_government_purchases",
      "government_postal_services"
    ] },
    { category: "logistics", subcategories: [
      "freight",
      "courier",
      "warehousing",
      "distribution",
      "end_to_end_logistics",
      "courier_services"
    ] },
    { category: "tours_and_travel", subcategories: [
      "aviation",
      "accommodation",
      "ota",
      "travel_agency",
      "tourist_attractions_and_exhibits",
      "timeshares",
      "aquariums_dolphinariums_and_seaquariums"
    ] },
    { category: "transport", subcategories: [
      "cab_hailing",
      "bus",
      "train_and_metro",
      "automobile_rentals",
      "cruise_lines",
      "parking_lots_and_garages",
      "transportation",
      "bridge_and_road_tolls",
      "freight_transport",
      "truck_and_utility_trailer_rentals"
    ] },
  
  ];
  selectedCategory:any
  selectedSubCategory:any
  onlinePaymentsData:any = []
  constructor(
    private navservice:NavigationService,
    private _apiservice:ApiService, private loaderservice: LoaderServiceService, private route: ActivatedRoute, private router: Router,private dialog:MatDialog
  ) {     this.navservice.hideSidebarAndNav = false;
    this._apiSubscription = this._apiservice.apiResult.subscribe(resData => {
      if(resData.responseType === SM_CONSTANTS.GET_BANK_INFO_RESULT){
        this.onlinePaymentsData = []
        if(resData.result.data.business_bank_details){

          // resData.result.forEach((element:any) => {
          //   this.onlinePaymentsData.push(element)
          //   this.onlinePaymentsData[0].account_type = parseInt(this.onlinePaymentsData[0].account_type)
          // });

          if(resData.result.data.business_bank_details){
              this.onlinePaymentsData.push(resData.result.data.business_bank_details)
              this.onlinePaymentsData[0].account_type = parseInt(this.onlinePaymentsData[0].account_type)

          }
          

          this.onlinePaymentsObj.hashId = this.onlinePaymentsData[0].hashId 
          this.onlinePaymentsObj.email = this.onlinePaymentsData[0].email 
          this.onlinePaymentsObj.phone = this.onlinePaymentsData[0].phone 
          this.onlinePaymentsObj.gst_number = this.onlinePaymentsData[0].gst_number 
          this.onlinePaymentsObj.bank_name = this.onlinePaymentsData[0].bank_name 
          this.onlinePaymentsObj.branch_name = this.onlinePaymentsData[0].branch_name
          this.onlinePaymentsObj.account_number = this.onlinePaymentsData[0].account_number 
          this.onlinePaymentsObj.account_holder_name = this.onlinePaymentsData[0].account_holder_name
          this.onlinePaymentsObj.ifsc_code = this.onlinePaymentsData[0].ifsc_code
          this.onlinePaymentsObj.pan_card_number = this.onlinePaymentsData[0].pan_card_number 
          this.onlinePaymentsObj.accountType = this.onlinePaymentsData[0].account_type ? this.onlinePaymentsData[0].account_type : 0
          this.onlinePaymentsObj.refund_period = this.onlinePaymentsData[0].refund_period ? this.onlinePaymentsData[0].refund_period : 5

          this.selectedBusinessType = this.onlinePaymentsData[0].business_type
          this.selectedCategory = this.businessCategories.filter((item:any) => item.category ==  this.onlinePaymentsData[0].business_category)[0]
          this.selectedSubCategory = this.onlinePaymentsData[0].sub_category

          console.log(this.selectedCategory);
          console.log(this.selectedSubCategory);
          
        }
        this.loaderservice.showLoader = false
        this.loader = false
      }
      if(resData.responseType === SM_CONSTANTS.UPDATE_BANK_INFO_RESULT){
        
        if(resData.result){
          
          if(resData.result.errorcode == 0){
            this.router.navigate(['../'], {relativeTo: this.route, queryParams: {
              entityHash: this.entityHashId
            }})

          }
          else if(resData.result.errorcode == 1){
            this.loaderservice.showLoader = false
            const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
              data : {
                title : 'Alert',
                message : resData.result.error?.error?.description ? resData.result.error?.error?.description : (resData.result.error?.description ? resData.result.error?.description : 'Some error occured.'),
                okbtn : 'Ok',
                cancelbtn : 'Cancel',
                type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
              },
              disableClose : true
            });
          }

        }
      }
    })
  }
  entityHashId: any
  isEdit: any
  loader: boolean = false
  ngOnInit(): void {
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash
      this.isEdit = data.isEdit

      
    }) 
    this.loaderservice.showLoader = true
    this.loader = true
    this._apiservice.getBankInfo(this.entityHashId)
  }
  badd:any = JSON.parse(localStorage.getItem('entAddressInfo')!)
  onSubmitOnlinePaymentsDetails(){

    let data = JSON.parse(JSON.stringify(this.onlinePaymentsObj))


    data.created_by = data.edited_by = localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
    data.business_hash_id = this.entityHashId
    data.isEdit = +this.isEdit
    Object.keys(data).forEach(key => {
      if ((data as any)[key] === null) {
        delete (data as any)[key];
      }
    });

    data.business_name = localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_NAME)
    data.business_type = this.selectedBusinessType
    data.business_category = this.selectedCategory?.category
    data.sub_category = this.selectedSubCategory
    data.address_line1 = this.badd.address_line.slice(0,100)
    data.address_line2 = this.badd.address_line.slice(0,100)
    data.city = this.badd.city
    data.state = this.badd.state
    data.postal_code = this.badd.zip
    data.online_payment_status = this.onlinePaymentsData[0].online_payment_status
    if(this.isEdit == 1){
      data.razorpay_account_id = this.onlinePaymentsData[0].razorpay_account_id 
      data.rzp_stakeholder_id = this.onlinePaymentsData[0].razorpay_stakeholder_id 
      data.rzp_product_id = this.onlinePaymentsData[0]?.rzp_product_id 
      
    }
    if(this.isEdit == 0 && !environment.production){
      // data.pan_card_number = "AAACL1234C"
    }

    // data.business_type = "individual"
    Object.keys(data).forEach(key => {
      if ((data as any)[key] === null) {
        delete (data as any)[key];
      }
    });
    console.log(data);
    this.loaderservice.showLoader = true
    this._apiservice.updateBankInfo(data)
  }
selectedBusinessType:any
  onCategorySelected(event:any){
    if(event){
      this.selectedCategory = event.value
      this.selectedSubCategory = null

      console.log(event);
      
    }
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }

}
